import state from './state';
import actions from './actions';
import mutations from './mutations';

const roles = {
  namespaced: true,
  state,
  actions,
  mutations,
};

export default roles;
